export default "__VITE_ASSET__25487f7a__"